import axios from "axios";
import { Incident } from "../../interfaces/IncidentInterface";

const { CancelToken } = axios;
const source = CancelToken.source();

const { REACT_APP_VEHICLES_API } = process.env;

export const getIncidents = async (
  customer: string,
  vehicleIds: Array<string> = [],
  userIds: Array<string> = [],
  cancelToken = source.token,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const vehicles = vehicleIds.join(",");
    const users = userIds.join(",");
    const url = `${REACT_APP_VEHICLES_API}/${customer}/incidents?vehicle_ids_in=${vehicles}&user_ids_in=${users}`;
    const res = await axios({
      method: "get",
      url,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return { data: res?.data?.data };
  } catch (e) {
    return { detail: e.response?.data };
  }
};

export const getIncident = async (customer: string, incidentId: string) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const url = `${REACT_APP_VEHICLES_API}/${customer}/incidents/${incidentId}`;
    const res = await axios({
      method: "get",
      url,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res?.data?.data };
  } catch (e) {
    return { detail: e.response?.data };
  }
};

export const createIncident = async (customer: string, incident: Incident) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const url = `${REACT_APP_VEHICLES_API}/${customer}/incidents`;
    const res = await axios({
      method: "post",
      url,
      headers: { Authorization: `Bearer ${token}` },
      data: { ...incident },
    });
    return { data: res?.data?.data };
  } catch (e) {
    throw e.response.data;
  }
};

export const editIncident = async (
  customer: string,
  incidentId: string,
  incidentDetails: Incident,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const url = `${REACT_APP_VEHICLES_API}/${customer}/incidents/${incidentId}`;
    const res = await axios({
      method: "put",
      url,
      headers: { Authorization: `Bearer ${token}` },
      data: { ...incidentDetails },
    });
    return { data: res?.data?.data };
  } catch (e) {
    throw e.response.data;
  }
};

export const deleteIncident = async (customer: string, incidentId: string) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const url = `${REACT_APP_VEHICLES_API}/${customer}/incidents/${incidentId}`;
    const res = await axios({
      method: "delete",
      url,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res?.data?.data };
  } catch (e) {
    return { data: e.response.data };
  }
};
